function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-3.000000, -5.000000)",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(3.000000, 5.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M17.1815,-0.0001 C16.9985,-0.0001 16.8135,0.0049 16.6335,0.0209 C14.4515,0.1709 12.8175,1.5809 11.9155,2.5879 C10.9765,1.6189 9.2855,0.2769 7.0895,0.2129 L6.8685,0.2119 C3.1025,0.2119 0.1515,3.0009 0.0055,6.6989 C-0.1285,10.0569 2.1625,12.8959 3.8985,14.7389 C6.1605,17.1439 9.5085,19.5769 11.6705,20.8259 C11.8505,20.9259 12.0485,20.9759 12.2475,20.9759 C12.4655,20.9759 12.6845,20.9159 12.8785,20.7949 C14.9765,19.4709 18.2255,16.9069 20.4025,14.4039 C22.0625,12.4899 24.2405,9.5569 23.9785,6.2109 C23.6995,2.6689 20.7765,-0.0001 17.1815,-0.0001 M17.1815,1.9999 C19.7225,1.9999 21.7875,3.8779 21.9845,6.3669 C22.1875,8.9649 20.3165,11.4499 18.8925,13.0919 C17.0685,15.1899 14.2505,17.4929 12.2305,18.8329 C10.2005,17.5989 7.3285,15.4679 5.3545,13.3689 C3.8675,11.7869 1.9005,9.3839 2.0035,6.7769 C2.1085,4.1319 4.1545,2.2119 6.8595,2.2119 L7.0315,2.2119 C8.5055,2.2549 9.7205,3.1969 10.4805,3.9799 L11.9745,5.5209 L13.4065,3.9219 C14.1345,3.1079 15.3105,2.1159 16.7975,2.0139 C16.9235,2.0029 17.0535,1.9999 17.1815,1.9999"
}))));

function SvgHeart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100px",
    width: "100px",
    fill: "#fff",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24 21",
    x: "0px",
    y: "0px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Fill 1@2x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.23deb4ad.svg";
export { ForwardRef as ReactComponent };